import React from "react";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";

const ElementSettingsProgressCode = (props) => {
  const element = props.element;

  return (
    <React.Fragment>
      <VariantBuilderSetting
        object={element}
        setting_name="[html]"
        setting_type="code"
        label="HTML Editor"
        object_type="elements"
        object_id={element.id}
        value={element.html ? element.html : ""}
        condition={element.options["progress-type"] == "static"}
        feature_gate_type="Custom HTML"
      />

      <VariantBuilderSetting
        object={element}
        setting_name="[options][progress-message-cart]"
        setting_type="code"
        label="HTML Editor"
        object_type="elements"
        object_id={element.id}
        value={
          element.options["progress-message-cart"]
            ? element.options["progress-message-cart"]
            : ""
        }
        condition={element.options["progress-type"] == "cart"}
        feature_gate_type="Custom HTML"
      />
    </React.Fragment>
  );
};

export default ElementSettingsProgressCode;
